// 3_pages/delivery_and_payment.js
// Makes every .item block on the deliveries-and-payments page expandable
// (a click toggles its "expanded" class).

export function init() {
	if (!window.NAT?.utils?.expandedToggle) {
		console.warn("[NAT] delivery_and_payment.js: window.NAT.utils.expandedToggle missing — check load order");
		return;
	}

	document.addEventListener("DOMContentLoaded", function () {
		deliveryAndPaymentPage();
	});
}

function deliveryAndPaymentPage() {
	const deliveriesAndPaymentsBlock = document.querySelector(".page-deliveries-and-payments");
	if (!deliveriesAndPaymentsBlock) return;

	const itemsToToggle = deliveriesAndPaymentsBlock.querySelectorAll(".item");
	if (!itemsToToggle || itemsToToggle.length === 0) return;
	itemsToToggle.forEach((item) => {
		window.NAT.utils.expandedToggle(item);
	});
}
